'use client'
import BacktoPagetopButton from '@/components/atoms/buttons/BacktoPagetopButton'
import styles from './style.module.scss'

const author = process.env.NEXT_PUBLIC_AUTHOR

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className="inner">
        <div className={styles.backToTop}>
          <BacktoPagetopButton />
        </div>
        <div className={styles.copyRight}>
          <span>{`Copyright ${new Date().getFullYear()} ${author}`}</span>
        </div>
      </div>
    </footer>
  )
}
